// assets/product-aminograma.js
// Selector de porciones para la tabla de aminograma.
// Estructura JSON esperada con porciones:
// { "porciones": [{ "label": "30g", "aminograma": [["L-Leucina","3000mg"], ...] }, ...] }
// Sin porciones (legacy): { "aminograma": [["L-Leucina","3000mg"], ...] }

(function() {
  'use strict';

  var SVG_ARROW = '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.1384 6.02928C3.32935 5.80651 3.66472 5.78071 ' +
    '3.88749 5.97165L8.50009 9.92531L13.1127 5.97165C13.3355 5.78071 13.6708 5.80651 13.8618 6.02928C14.0527 ' +
    '6.25204 14.0269 6.58742 13.8042 6.77837L8.84582 11.0284C8.64688 11.1989 8.3533 11.1989 8.15436 11.0284L3.19602 ' +
    '6.77836C2.97326 6.58742 2.94746 6.25204 3.1384 6.02928Z" fill="black"/></svg>';

  function getWeight(label) {
    var match = label.match(/(\d+(?:[.,]\d+)?)/);
    return match ? parseFloat(match[1].replace(',', '.')) : Infinity;
  }

  function normalizeAminoAcids(amino_acids) {
    if (!amino_acids) return null;
    if (Array.isArray(amino_acids)) {
      if (amino_acids.length > 0 && amino_acids[0] && amino_acids[0].nombre !== undefined) {
        return amino_acids.map(function(v) { return [v.nombre, v.valor || '—']; });
      }
      return amino_acids;
    }
    if (typeof amino_acids === 'object') return Object.entries(amino_acids);
    return null;
  }

  function getPortionAminoData(portion) {
    return portion.aminograma || portion.valores;
  }

  function renderAminogramaFooter(container, footerLines) {
    var el = container.querySelector('.aminograma-footer');
    if (!footerLines || !Array.isArray(footerLines) || footerLines.length === 0) {
      if (el) el.style.display = 'none';
      return;
    }
    if (!el) {
      el = document.createElement('p');
      el.className = 'aminograma-footer';
      var inner = container.querySelector('.product-aminograma__inner');
      if (inner) inner.appendChild(el);
    }
    el.style.display = '';
    el.innerHTML = footerLines.map(function(line) {
      if (line.indexOf('DDR') !== -1 || line.indexOf('VRN') !== -1) {
        var idx = line.indexOf(': ');
        if (idx === -1) return '<em>' + line + '</em>';
        return '<em><strong>' + line.substring(0, idx) + '</strong>: ' + line.substring(idx + 2) + '</em>';
      }
      return line;
    }).join('<br>');
  }

  function renderAminogramaRows(tab, rawAminoAcids) {
    var amino_acids = normalizeAminoAcids(rawAminoAcids);
    var rowsContainer = tab.querySelector('.aminograma-rows');
    if (!rowsContainer || !amino_acids) return;

    rowsContainer.innerHTML = '';
    var amino_count = 0;
    var currentRow = null;

    amino_acids.forEach(function(amino_acid, index) {
      amino_count++;
      var is_odd = amino_count % 2 === 1;

      if (is_odd) {
        currentRow = document.createElement('div');
        currentRow.className = 'aminograma-row';
        var col = document.createElement('div');
        col.className = 'aminograma-col';
        col.innerHTML = '<span class="aminograma-name">' + amino_acid[0] + '</span>' +
                        '<span class="aminograma-value">' + amino_acid[1] + '</span>';
        currentRow.appendChild(col);
      } else {
        var col = document.createElement('div');
        col.className = 'aminograma-col';
        col.innerHTML = '<span class="aminograma-name">' + amino_acid[0] + '</span>' +
                        '<span class="aminograma-value">' + amino_acid[1] + '</span>';
        currentRow.appendChild(col);
        rowsContainer.appendChild(currentRow);
        currentRow = null;
      }

      if (is_odd && index === amino_acids.length - 1) {
        var emptyCol = document.createElement('div');
        emptyCol.className = 'aminograma-col empty';
        currentRow.appendChild(emptyCol);
        rowsContainer.appendChild(currentRow);
      }
    });
  }

  window.initAminogramaSelector = function(tab) {
    var existing = tab.querySelector('.aminograma-selector');
    if (existing) existing.remove();

    var button = tab.querySelector('.m-collapsible--button');
    var dataScript = tab.querySelector('.aminograma-data');
    if (!button || !dataScript) return;

    var rawData;
    try { rawData = JSON.parse(dataScript.textContent); } catch (e) { return; }

    var porciones = rawData.porciones;
    if (!porciones || !Array.isArray(porciones) || porciones.length === 0) return;

    porciones.sort(function(a, b) { return getWeight(a.label) - getWeight(b.label); });

    var contentContainer = tab.querySelector('.collapsible-aminograma-content') || tab;
    renderAminogramaFooter(contentContainer, rawData.footer);

    renderAminogramaRows(tab, getPortionAminoData(porciones[0]));

    if (porciones.length === 1) {
      var staticWrapper = document.createElement('div');
      staticWrapper.className = 'aminograma-selector';
      staticWrapper.style.cssText = 'position:absolute; right:4rem; display:none; align-items:center;';
      staticWrapper.addEventListener('click', function(e) { e.stopPropagation(); });
      var staticDisplay = document.createElement('div');
      staticDisplay.className = 'aminograma-selector-display';
      staticDisplay.style.cssText = 'position:relative; display:flex; align-items:center; z-index:1; left:8%;';
      var staticText = document.createElement('span');
      staticText.className = 'aminograma-selected-text';
      staticText.textContent = porciones[0].label;
      staticText.style.setProperty('font-size', '14px', 'important');
      staticText.style.setProperty('font-weight', 'normal', 'important');
      staticText.style.setProperty('line-height', 'normal', 'important');
      staticText.style.setProperty('white-space', 'normal', 'important');
      staticDisplay.appendChild(staticText);
      var vrnLabel = porciones[0].vrn_label || '';
      if (vrnLabel) {
        var vrnEl = document.createElement('span');
        vrnEl.className = 'aminograma-vrn-text';
        vrnEl.innerHTML = vrnLabel;
        vrnEl.style.setProperty('font-size', '14px', 'important');
        vrnEl.style.setProperty('line-height', 'normal', 'important');
        vrnEl.style.setProperty('margin-left', '0', 'important');
        vrnEl.style.setProperty('white-space', 'nowrap', 'important');
        staticDisplay.appendChild(vrnEl);
      }
      staticWrapper.appendChild(staticDisplay);
      button.style.position = 'relative';
      button.appendChild(staticWrapper);
      var obs = new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.attributeName === 'aria-expanded') {
            staticWrapper.style.display = button.getAttribute('aria-expanded') === 'true' ? 'flex' : 'none';
          }
        });
      });
      obs.observe(button, { attributes: true });
      if (button.getAttribute('aria-expanded') === 'true') {
        staticWrapper.style.display = 'flex';
      }
      return;
    }

    var selectorWrapper = document.createElement('div');
    selectorWrapper.className = 'aminograma-selector';
    selectorWrapper.style.cssText = 'position:absolute; right:4rem; display:none; align-items:center; cursor:pointer;';
    selectorWrapper.addEventListener('click', function(e) { e.stopPropagation(); });

    var arrowIcon = document.createElement('span');
    arrowIcon.className = 'aminograma-selector-arrow';
    arrowIcon.innerHTML = SVG_ARROW;

    var select = document.createElement('select');
    select.id = 'aminograma-portion';
    select.style.cssText = 'position:absolute; left:0; top:0; width:100%; height:100%; opacity:0; cursor:pointer; z-index:2; border:none; background:transparent;';
    select.addEventListener('click', function(e) { e.stopPropagation(); });
    select.addEventListener('focus', function() { arrowIcon.classList.add('rotated'); });
    select.addEventListener('blur', function() { arrowIcon.classList.remove('rotated'); });
    select.addEventListener('change', function() {
      setTimeout(function() {
        if (document.activeElement !== select) arrowIcon.classList.remove('rotated');
      }, 100);
    });

    var displayContent = document.createElement('div');
    displayContent.className = 'aminograma-selector-display';
    displayContent.style.cssText = 'position:relative; display:flex; align-items:center; pointer-events:none; z-index:1; left:8%;';

    var selectedText = document.createElement('span');
    selectedText.className = 'aminograma-selected-text';
    selectedText.textContent = porciones[0].label;
    selectedText.style.setProperty('font-size', '14px', 'important');
    selectedText.style.setProperty('font-weight', 'normal', 'important');
    selectedText.style.setProperty('line-height', 'normal', 'important');
    selectedText.style.setProperty('white-space', 'normal', 'important');
    displayContent.appendChild(selectedText);

    var vrnText = document.createElement('span');
    vrnText.className = 'aminograma-vrn-text';
    var firstVrn = porciones[0].vrn_label || '';
    vrnText.innerHTML = firstVrn;
    vrnText.style.setProperty('font-size', '14px', 'important');
    vrnText.style.setProperty('line-height', 'normal', 'important');
    vrnText.style.setProperty('margin-left', '0', 'important');
    vrnText.style.setProperty('white-space', 'nowrap', 'important');
    if (!firstVrn) vrnText.style.display = 'none';
    displayContent.appendChild(vrnText);

    displayContent.appendChild(arrowIcon);
    selectorWrapper.appendChild(displayContent);
    selectorWrapper.appendChild(select);

    porciones.forEach(function(p, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = p.label;
      if (i === 0) opt.selected = true;
      select.appendChild(opt);
    });

    button.style.position = 'relative';
    button.appendChild(selectorWrapper);

    select.addEventListener('change', function() {
      var idx = parseInt(select.value);
      var portion = porciones[idx];
      if (portion) renderAminogramaRows(tab, getPortionAminoData(portion));
      selectedText.textContent = porciones[idx].label;
      var vrnLabel = porciones[idx].vrn_label || '';
      vrnText.innerHTML = vrnLabel;
      vrnText.style.display = vrnLabel ? '' : 'none';
    });

    var obs = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.attributeName === 'aria-expanded') {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          selectorWrapper.style.display = expanded ? 'flex' : 'none';
        }
      });
    });
    obs.observe(button, { attributes: true });

    if (button.getAttribute('aria-expanded') === 'true') {
      selectorWrapper.style.display = 'flex';
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('collapsible-tab').forEach(function(tab) {
      if (tab.querySelector('.aminograma-data')) {
        window.initAminogramaSelector(tab);
      }
    });
  });
})();
